export const accountsAbsoluteBaseUrl =
  process.env.APP_NAME === 'accounts' && process.env.VERCEL_ENV === 'preview'
    ? `https://${process.env.VERCEL_BRANCH_URL}`
    : process.env.NEXT_PUBLIC_ACCOUNTS_BASE_URL || '';
export const cloudAbsoluteBaseUrl =
  process.env.APP_NAME === 'cloud' && process.env.VERCEL_ENV === 'preview'
    ? `https://${process.env.VERCEL_BRANCH_URL}`
    : process.env.NEXT_PUBLIC_CLOUD_BASE_URL || '';
export const websiteAbsoluteBaseUrl =
  process.env.APP_NAME === 'website' && process.env.VERCEL_ENV === 'preview'
    ? `https://${process.env.VERCEL_BRANCH_URL}`
    : process.env.NEXT_PUBLIC_WEBSITE_BASE_URL || '';
export const docsAbsoluteBaseUrl = `${websiteAbsoluteBaseUrl}/docs`;
export const hubAbsoluteBaseUrl = `${websiteAbsoluteBaseUrl}/hub`;
export const accountsBaseUrl = process.env.APP_NAME === 'accounts' ? '' : accountsAbsoluteBaseUrl;
export const cloudBaseUrl = process.env.APP_NAME === 'cloud' ? '' : cloudAbsoluteBaseUrl;
export const docsBaseUrl = process.env.APP_NAME === 'docs' ? '' : docsAbsoluteBaseUrl;
export const hubBaseUrl = process.env.APP_NAME === 'hub' ? '' : hubAbsoluteBaseUrl;
export const websiteBaseUrl = process.env.APP_NAME === 'website' ? '' : websiteAbsoluteBaseUrl;
